import { useRef, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';
import gsap from 'gsap';


export default function Fog() {
    const location = useLocation();
    const { scene } = useThree();
    const fogRef = useRef();
    
    useEffect(() => {
        if (!fogRef.current) {
            fogRef.current = new THREE.Fog(new THREE.Color('#fbf8f4'), 100, 600);
            scene.fog = fogRef.current;
        }
        let newFogNear, newFogFar;

        switch (location.pathname) {
            case '/':
                newFogNear = 100;
                newFogFar = 300;
                break;
            case '/map':
                newFogNear = 800;
                newFogFar = 1800;
                break;
            case '/about':
                newFogNear = 600;
                newFogFar = 2000;
                break;
            case '/energyflow':
                newFogNear = 500;
                newFogFar = 1000;
                break;
            case '/smartpowering':
                newFogNear = 200;
                newFogFar = 480;
                break;
            case '/villelaboratoire':
                newFogNear = 600;
                newFogFar = 1000;
                break;
            case '/routescampagne':
                newFogNear = 700;
                newFogFar = 1200;
                break;
            case '/autoroute':
                newFogNear = 900;
                newFogFar = 1200;
                break;
            case '/autonomy':
                newFogNear = 400;
                newFogFar = 520;
                break;
            default:
                newFogNear = 50;
                newFogFar = 800;
                break;
        }
        gsap.to(scene.fog, {
            near: newFogNear,
            far: newFogFar,
            duration: 4,
            ease: 'power2.out',
        });

    }, [location, scene]);

    return null;
}
